$(document).ready(function(){


    function getCookie(name) {
        let cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            let cookiePair = cookies[i].split('=');
            if (cookiePair[0] === name) {
                return decodeURIComponent(cookiePair[1]); // Decode the stored value
            }
        }
        return null; // Return null if cookie not found
    }

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(value) + "; path=/;" + expires;
    }

    $('.cp_choose_flavour_grid.carousel_choose').slick({
        dots: false,
        arrows: true,
        slidesToShow: 3,
        prevArrow:
        "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Button_-_Next.png?v=1749240933'/></button>",
        nextArrow:
        "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Button_-_Next.png?v=1749240933'/></button>",  
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }
        ]
    });

    $('.cp_choose_bundles_grid.carousel').slick({
        dots: false,
        arrows: true,
        slidesToShow: 2,
        prevArrow:
        "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Button_-_Next.png?v=1749240933'/></button>",
        nextArrow:
        "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Button_-_Next.png?v=1749240933'/></button>",  
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }
        ]
    });



    $(".pure_quiz_grid_block").click(function () {
      var currentIndex = $(this).closest(".pure_quiz_inner").attr("data-index");
      showNextQuestion(currentIndex);
  
      var isPoop = $(this).closest(".pure_quiz_inner").attr("data-poop");
      var isPoopValue = '';
      if (isPoop == 'true'){
        isPoopValue = $(this).find('.pure_quiz_answer').html();
        $('.pure_quiz_data').attr('data-poop', isPoopValue);
      }
    });
  
    $(".pure_quiz_btn").click(function () {
      var mode = $(this).attr('data');
      if (mode == 'email_step'){
        var getEmail = String($('.pure_quiz_email_collection__js').val());
        
        if (getEmail.indexOf('@') != -1){
          console.log(getEmail);
          sendKlaviyoEmail();
        }
  
        
      }
      else{
        if ($(this).hasClass("disabled")) {
        } else {
          var currentAnswer = false;
          var index = 0;

          $(this).closest('.pure_quiz_inner').find('.pure_quiz_grid_long_cell.active').find('.productTrigger').each(function(){
            if (index == 0){
              currentAnswer = $(this).html();
              index++;
            }
          });

          if (currentAnswer != false){
            setCookie("productTrigger", currentAnswer, 31);
          }

          var currentIndex = $(this).closest(".pure_quiz_inner").attr("data-index");
          showNextQuestion(currentIndex);
        }
      }
      
    });
    
    $(".multiSelect").click(function () {
      var currentAnswer = $(this).attr('data');
      if (currentAnswer == 'none' || currentAnswer == 'prefer-not-to-say'){
        $(this).closest('.pure_quiz_grid').find('.multiSelect').removeClass('active');
      }
      else{
        $('.multiSelect[data="none"]').removeClass('active');
        $('.multiSelect[data="prefer-not-to-say"]').removeClass('active');
      }
      $(this).toggleClass("active");
      var allActives = 0;
      $(this)
        .closest(".pure_quiz_inner")
        .find(".multiSelect.active")
        .each(function () {
          allActives++;
        });
  
      if (allActives > 0) {
        $(this)
          .closest(".pure_quiz_inner")
          .find(".pure_quiz_btn")
          .removeClass("disabled");
      } else {
        $(this)
          .closest(".pure_quiz_inner")
          .find(".pure_quiz_btn")
          .addClass("disabled");
      }
  
      console.log(allActives);
    });


    function showPrevQuestion(currentIndex) {
      if (currentIndex > 1) {
        var nextIndex = parseFloat(currentIndex) - 1;
        console.log(nextIndex);
        $(".pure_quiz_inner").removeClass("visible");
        $('.pure_quiz_inner[data-index="' + nextIndex + '"]').addClass("visible");
  
        var totalQuestions = parseFloat($('.pure_quiz_nav_count').attr('data'));
        var percentage = ((totalQuestions - nextIndex) * 100) / totalQuestions;
        percentage = 100 - percentage;
  
        $(".pure_quiz_progress_inner").css("width", percentage + "%");
        $(".pure_quiz_nav_count").html(nextIndex + " of " + totalQuestions);
      }
    }


    function showNextQuestion(currentIndex) {
      var currentIndex = parseFloat(currentIndex);
      var nextIndex = parseFloat(currentIndex) + 1;
      // console.log(nextIndex);
      
      var totalQuestions = parseFloat($('.pure_quiz_nav_count').attr('data'));
      var productAnswer = getCookie("productTrigger");
      console.log(productAnswer, 'PRODUCT ANSWER IS');

      if (productAnswer == '⚡ Energy boost'){
        var nextUrl = $('.pure_quiz_outer').attr('data-url-energy-boost');
      }
      else if (productAnswer == '🍃 Relaxation'){
        var nextUrl = $('.pure_quiz_outer').attr('data-url-relaxation');
      }
      else if (productAnswer == '😴 Sleep'){
        var nextUrl = $('.pure_quiz_outer').attr('data-url-sleep');
      }
      else if (productAnswer == '🚨 Staying alert'){
        var nextUrl = $('.pure_quiz_outer').attr('data-url-staying-alert');
      }
      else if (productAnswer == '✨ Other benefits'){
        var nextUrl = $('.pure_quiz_outer').attr('data-url-other-benefits');
      }
      
      if (totalQuestions == currentIndex){
        window.location.href = nextUrl;
      }
      else{
        $(".pure_quiz_inner").removeClass("visible");
        $('.pure_quiz_inner[data-index="' + nextIndex + '"]').addClass("visible");
  
        var percentage = ((totalQuestions - nextIndex) * 100) / totalQuestions;
        percentage = 100 - percentage;
    
        $(".pure_quiz_progress_inner").css("width", percentage + "%");
        $(".pure_quiz_nav_count").html(nextIndex + " of " + totalQuestions);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
  
      $(".pure_quiz_go_back").css('opacity', '1');
      
    }
    

    $(".pure_quiz_go_back").click(function () {
      var currentIndex = parseFloat($(".pure_quiz_inner.visible").attr("data-index"));
      if (currentIndex == 2){
        $(".pure_quiz_go_back").css('opacity', '0');
      }
      console.log(currentIndex, " current index");
      showPrevQuestion(currentIndex);
    });

});